<template>
  <div
    class="desktop-slider-container"
    @mouseover="pauseCarousel"
    @mouseout="resumeCarousel"
  >
    <div class="desktop-slider">
      <button class="desktop-arrow desktop-left" @click="prevSlide">
        <i class="fa fa-chevron-left"></i>
      </button>
      <div
        class="desktop-slide-wrapper"
        :style="sliderWrapperStyle"
        ref="slideWrapper"
      >
        <div
          v-for="(images, index) in loopedImages"
          :key="index"
          class="desktop-slide"
        >
          <img
            :src="images.image"
            alt="images.alt"
            class="desktop-slide-image"
          />
        </div>
      </div>
      <button class="desktop-arrow desktop-right" @click="nextSlide">
        <i class="fa fa-chevron-right"></i>
      </button>

      <div class="desktop-btn-edit-carousel" v-if="$store.state.role_id == 1">
        <button class="desktop-edit-carousel" @click="openEditCarousel">
          Edit Carousel
        </button>
      </div>
    </div>
    <div v-if="editCarousel">
      <modal-carousel
        :images="images"
        @closeModalCarousel="closeEditCarousel"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  components: {
    ModalCarousel: () => import('@/components/ModalCarousel.vue'),
  },

  data() {
    return {
      currentIndex: 0,
      loopInterval: null,
      slideWidth: 900,
      slideMargin: 25,
      containerWidth: 1100,
      editCarousel: false,
    }
  },
  computed: {
    shouldAutoSlide() {
      return this.images.length > 1;
    },
    sliderWrapperStyle() {
      if (this.images.length > 1) {
        const sliderWidth =
          this.loopedImages.length * (this.slideWidth + this.slideMargin)
        const offset =
          (this.containerWidth - this.slideWidth) / 2 -
          this.currentIndex * (this.slideWidth + this.slideMargin)
  
        return {
          width: `${sliderWidth}px`,
          transform: `translateX(${offset}px)`,
          transition: 'transform 0.5s ease-in-out',
        }
      } else {
        const sliderWidth = 1100
        const offset =
          (this.containerWidth - this.slideWidth) / 2 -
          this.currentIndex * (this.slideWidth + this.slideMargin);

        return {
          width: `${sliderWidth}px`,
          transform: `translateX(${offset}px)`,
        };
      }
    },
    
    loopedImages() {
      const numberOfSlides = this.images.length > 1 ? 9 : 1;
      const repeatedImages = []

      for (let i = 0; i < numberOfSlides; i++) {
        repeatedImages.push(...this.images)
      }

      return repeatedImages
    },
  },
  mounted() {
    if (this.shouldAutoSlide) {
      this.startLoop();
    }
  },
  methods: {
    startLoop() {
      // this.loopInterval = setInterval(() => this.nextSlide(), 7000);
      clearInterval(this.loopInterval)

      this.loopInterval = setInterval(() => this.nextSlide(), 7000)
    },
    prevSlide() {
      clearInterval(this.loopInterval)
      if (this.currentIndex === 0) {
        this.currentIndex = this.loopedImages.length - 1
      } else {
        this.currentIndex = (this.currentIndex - 1) % this.loopedImages.length
      }
      this.startLoop()
    },
    nextSlide() {
      clearInterval(this.loopInterval)
      this.currentIndex = (this.currentIndex + 1) % this.loopedImages.length
      this.startLoop()
    },
    openEditCarousel() {
      this.editCarousel = true
    },

    closeEditCarousel() {
      this.editCarousel = false
    },

    pauseCarousel() {
      clearInterval(this.loopInterval)
    },

    resumeCarousel() {
      this.startLoop()
    },
  },
  beforeDestroy() {
    clearInterval(this.loopInterval)
  },
}
</script>

<style scoped>
.desktop-slider-container {
  width: 1100px;
  height: 230px;
  overflow: hidden;
  margin: 20px auto 0 auto;
}
.desktop-slider {
  position: relative;
  overflow: hidden;
}
.desktop-slide-wrapper {
  display: flex;
  flex-direction: row;
  transition: transform 0.5s ease-in-out;
}
.desktop-slide {
  width: 900px;
  height: 230px;
  margin-right: 25px;
  flex-shrink: 0;
}
.desktop-slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.desktop-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #fff;
  background-color: red;
  border-radius: 18px;
  width: 30.94px;
  height: 30.94px;
  border: none;
  cursor: pointer;
  z-index: 1;
}

.desktop-slider-container:hover .desktop-left {
  opacity: 1;
  left: 60px;
}

.desktop-left {
  left: 100px;
  opacity: 0;
  transition: 0.7s ease all;
}

.desktop-slider-container:hover .desktop-right {
  opacity: 1;
  right: 60px;
}

.desktop-right {
  right: 100px;
  opacity: 0;
  transition: 0.7s ease all;
}

.desktop-slider-container:hover .desktop-btn-edit-carousel {
  opacity: 1;
}

.desktop-btn-edit-carousel {
  padding: 8px;
  gap: 12px;
  opacity: 0;

  position: absolute;
  right: 110px;
  bottom: 10px;
  transition: 0.5s ease all;

  font-size: 12px;
}

.desktop-edit-carousel {
  padding: 0.1rem 0.4rem;
  background: rgba(255, 0, 0, 0.9);
  color: white;
  border-radius: 3px;
  box-shadow: 0px 0px 1px 1px gray;
  border: none;
}
</style>
